// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Oz7kp","container__content":"styles_container__content__Uwkbg","skeleton-animation":"styles_skeleton-animation__tQTdx"};